import React from "react";
import "./../RaportyRozhana/NavbarRozhana.css";
import { ProductConsumer } from "../../../Context/AddProWakel";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
const NavbarOfKas = () => {
  return (
    <ProductConsumer>
      {(value) => {
        const {
          RT_Paradanakan,
          RT_mandubakan,
          RT_paradan,
          RT_mandub,
          RT_getPrint,
          PD_parayesta_RRR,
          RT_filter
        } = value;

        return (
          <div>
            <div
              className="sidebar text-warning  font-weight-bold f4"
              style={{ backgroundColor: "#2C3539" }}
            >
              <center>
                <h4 className="text-white pr2">جووڵەی کەسەکان</h4>
              </center>
              <td>
                <div className="row d-flex">
                  <div className="col-lg-3 ">
                    <button
                      onClick={() => RT_filter("$")}
                      className="btn btn-success"
                    >
                      $
                    </button>
                  </div>
                  <div className="col-lg-3 ">
                    <button
                      onClick={() => RT_filter("ID")}
                      className="btn btn-danger"
                    >
                      ID
                    </button>
                  </div>
                  <div className="col-lg-3 ">
                    <button
                      onClick={() => RT_filter("R")}
                      className="btn btn-warning"
                    >
                      R
                    </button>
                  </div>
                  <div className="col-lg-3 ">
                    <button
                      onClick={() => RT_filter("A")}
                      className="btn btn-info"
                    >
                      A
                    </button>
                  </div>
                </div>
              </td>
              <td
                style={{
                  backgroundColor: `${RT_paradan == true ? "#63120f" : ""}`
                }}
              >
                <span
                  className={`font-weight-bold  pointer`}
                  onClick={RT_Paradanakan}
                  style={{ paddingLeft: "80px" }}
                >
                  پارەدان
                </span>
              </td>
              <td
                style={{
                  backgroundColor: `${RT_mandub == true ? "#63120f" : ""}`
                }}
              >
                <span
                  className={`font-weight-bold  pointer`}
                  onClick={RT_mandubakan}
                  style={{ paddingLeft: "80px" }}
                >
                  مافی.کۆمپانیا
                </span>
              </td>
              <td>
                <span
                  className={`font-weight-bold  pointer`}
                  onClick={RT_getPrint}
                  style={{ paddingLeft: "80px" }}
                >
                  <Link to="/print-kas" className="text-warning">
                    چاپکردن
                  </Link>
                </span>
              </td>
              <br />
              <br />
              <td>
                <span
                  className={`font-weight-bold  pointer`}
                  style={{ paddingLeft: "80px" }}
                >
                  RRR ڕەسیدی
                </span>
              </td>
              <td>
                <span
                  className={`font-weight-bold  pointer`}
                  style={{ paddingLeft: "50px" }}
                >
                  <NumberFormat
                    value={PD_parayesta_RRR}
                    className="bg-white f3 font-weight-bold  tc border-0 text-dark"
                    displayType={"text"}
                    prefix={"Y"}
                    thousandSeparator={true}
                  />
                </span>
              </td>
            </div>
          </div>
        );
      }}
    </ProductConsumer>
  );
};
export default NavbarOfKas;
